import React from 'react'
import Loadable from 'react-loadable'
// import jwt from 'jsonwebtoken'
import LoadingSheet from './Components/LoadingSheet'
import LoadingDetailPerusahaan from './Components/LoadingDetailPerusahaan'
import LoadingList from './Components/LoadingList'

const style = {
    minHeight:'50rem'
}

function Loading() {
    return (<div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>)
}

const Home = Loadable({
    loader: () => import('./views/Home'),
    loading: LoadingSheet,
})

const Dashboard = Loadable({
    loader: () => import('./views/Dashboard'),
    loading: LoadingDetailPerusahaan,
})

const PetaStatus = Loadable({
    loader: () => import('./views/Dashboard/PetaStatus'),
    loading: LoadingSheet,
})

const InputAsesment = Loadable({
    loader: () => import('./views/InputAsesment'),
    loading: LoadingList,
})

const DetailPerusahaan = Loadable({
    loader: () => import('./views/DetailPerusahaan'),
    loading: LoadingDetailPerusahaan,
})

const DataAsesment = Loadable({
    loader: () => import('./views/DataAsesment'),
    loading: LoadingList,
})

const Logs = Loadable({
    loader: () => import('./views/Logs'),
    loading: LoadingList
})

const FormExecutiveSummary = Loadable({
    loader: () => import('./views/FormExecutiveSummary'),
    loading: LoadingSheet,
})


const Profile = Loadable({
    loader: () => import('./views/Profile'),
    loading: LoadingSheet,
})

const MasterData = Loadable({
    loader: () => import('./views/MasterData'),
    loading: LoadingList,
})

const MasterPerusahaan = Loadable({
    loader: () => import('./views/MasterData/MasterPerusahaan'),
    loading: LoadingList,
})
const MasterPerusahaanAsessor = Loadable({
    loader: () => import('./views/MasterData/MasterPerusahaanAsessor'),
    loading: LoadingList,
})
const MasterSheet = Loadable({
    loader: () => import('./views/MasterData/MasterSheet'),
    loading: LoadingList,
})
const MasterJenisPerusahaan = Loadable({
    loader: () => import('./views/MasterData/MasterJenisPerusahaan'),
    loading: LoadingList,
})
const MasterJenisSheet = Loadable({
    loader: () => import('./views/MasterData/MasterJenisSheet'),
    loading: LoadingList,
})
const MasterUser = Loadable({
    loader: () => import('./views/MasterData/MasterUser'),
    loading: LoadingList,
})
const MasterUserPerusahaan2 = Loadable({
    loader: () => import('./views/MasterData/MasterUserPerusahaan'),
    loading: LoadingList,
})
const MasterTahun = Loadable({
    loader: () => import('./views/MasterData/MasterTahun'),
    loading: LoadingList,
})

// const FormPenilaian = Loadable({
//     loader: () => import('./views/FormPenilaian'),
//     loading: Loading,
// })

const LihatAsesment = Loadable({
    loader: () => import('./views/LihatAsesment'),
    loading: LoadingList,
})

// const FormSheet = Loadable({
//     loader: () => import('./views/MasterData/FormSheet'),
//     loading: LoadingSheet,
// })

const FormTemuan = Loadable({
    loader: () => import('./views/FormTemuan'),
    loading: LoadingSheet,
})

const ChangeRole = Loadable({
    loader: () => import('./views/ChangeRole'),
    loading: LoadingList,
})

const MasterParentPerusahaan = Loadable({
    loader: () => import('./views/MasterData/MasterParentPerusahaan'),
    loading: LoadingList,
})

const MasterDetailSheet = Loadable({
    loader: () => import('./views/MasterData/MasterSheet/MasterDetailSheet'),
    loading: LoadingSheet,
})
const DetailSheet = Loadable({
    loader: () => import('./views/LayoutPertanyaan/DetailSheet'),
    loading: LoadingSheet,
})

// './views/MasterData/SettingBobot'
const SettingBobot = Loadable({
    loader: () => import('./views/MasterData/SettingBobot'),
    loading: LoadingDetailPerusahaan,
})
const LogApp = Loadable({
    loader: () => import('./views/LogApp'),
    loading: Loading,
})

const routes = [
    {path: '/home', exact: true, name: 'Home', component: (props) => (
        <Home {...props} />
    )},
    {path: '/profile', exact: true, name: 'Profile', component: (props) => (
        <Profile {...props} />
    )},
    {path: '/dashboard', exact: true, name: 'Dashboard AFC', component: (props) => (
        <Dashboard {...props} />
    )},
    {path: '/dashboard/peta-status', exact: true, name: 'Peta Status', component: (props) => (
        <PetaStatus {...props} />
    )},
    {path: '/input-asesment', exact: true, name: 'Input Assessment', component: (props) => (
        <InputAsesment {...props} />
    )},
    {path: '/input-asesment/:id', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <DetailPerusahaan {...props} />
    )},
    {path: '/input-asesment/:id/sheet/:sheetId', exact: true, name: 'Penilaian', component: (props) => (
        <DetailSheet {...props} penilaian />
    )},
    {path: '/input-asesment/:id/executive-summary', exact: true, name: 'Executive Summary', component: (props) => (
        <FormExecutiveSummary {...props} />
    )},
    {path: '/input-asesment/:id/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )
    },
    {path: '/input-asesment/:id/:tahun/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )},
    {path: '/data-asesment', exact: true, name: 'Data Assessment', component: (props) => (
        <DataAsesment {...props} tahun="2018" />
    )},
    {path: '/data-asesment/:id/logs', exact: true, name: 'Log Perusahaan', component: (props) => (
        <Logs {...props} />
    )},
    {path: '/data-asesment/:id/:tahun', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <DetailPerusahaan {...props} />
    )},
    {path: '/data-asesment/:id/:tahun/sheet/:sheetId', exact: true, name: 'Detail Sheet', component: (props) => (
        <DetailSheet {...props} />
    )},
    {path: '/data-asesment/:id/:tahun/executive-summary', exact: true, name: 'Executive Summary', component: (props) => (
        <FormExecutiveSummary {...props} />
    )},
    {path: '/data-asesment/:id/:tahun/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )},
    {path: '/master-data', exact: true, name: 'Master Data', component: (props) => (
        <MasterData {...props} />
    )},
    {path: '/master-perusahaan', exact: true, name: 'Master Instalasi', component: (props) => (
        <MasterPerusahaan {...props} />
    )
    },
    {path: '/master-parent-perusahaan', exact: true, name: 'Master Perusahaan', component: (props) => (
        <MasterParentPerusahaan {...props} />
    )},
    {path: '/master-perusahaan/:id/asessor', exact: true, name: 'Master Perusahaan', component: (props) => (
        <MasterPerusahaanAsessor {...props} />
    )},
    {path: '/master-sheet', exact: true, name: 'Master Sheet', component: (props) => (
        <MasterSheet {...props} />
    )
    },
    {path: '/master-sheet/:id', exact: true, name: 'Master Detail Sheet', component: (props) => (
        <MasterDetailSheet {...props} edit />
    )},
    {path: '/master-jenis-kriteria', exact: true, name: 'Master Jenis Kriteria', component: (props) => (
        <MasterJenisPerusahaan {...props} />
    )},
    {path: '/master-jenis-kriteria/:id/sheet', exact: true, name: 'Sheet', component: (props) => (
        <MasterJenisSheet {...props} />
    )},
    // {path: '/master-jenis-kriteria/:id/sheet/:sheetPerusahaanId', exact: true, name: 'Detail Sheet', component: (props) => (
    //     <FormSheet {...props} />
    // )},
    {path: '/master-user', exact: true, name: 'Master User', component: (props) => (
        <MasterUser {...props} />
    )},
    {path: '/master-user/:id/perusahaan', exact: true, name: 'Perusahaan', component: (props) => (
        <MasterUserPerusahaan2 {...props} />
    )},
    {path: '/master-tahun', exact: true, name: 'Setting Tahun Aktif', component: (props) => (
        <MasterTahun {...props} />
    )},
    {path: '/lihat-asesment', exact: true, name: 'Lihat Assessment', component: (props) => (
        <LihatAsesment {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <DetailPerusahaan {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun/sheet/:sheetId', exact: true, name: 'Detail Perusahaan', component: (props) => (
        <DetailSheet {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun/executive-summary', exact: true, name: 'Executive Summary', component: (props) => (
        <FormExecutiveSummary {...props} />
    )},
    {path: '/lihat-asesment/:id/:tahun/form-temuan', exact: true, name: 'Form Temuan', component: (props) => (
        <FormTemuan {...props} />
    )},
    {path: '/change-role', exact: true, name: 'Change Role', component: (props) => (
        <ChangeRole {...props} />
    )
    },
    {path: '/setting-bobot', exact: true, name: 'Setting Bobot & Nilai Program', component: (props) => (
        <SettingBobot {...props} />
    )},
    {path: '/logs', exact: true, name: 'Logs', component: (props) => (
        <LogApp {...props} />
    )},
]

export default routes;